import { PRICING_STRATEGY_SCHEMA, PRICING_STRATEGY } from '@schuettflix/interfaces';

export function getCompatiblePricingStrategies(selectedPricingStrategies: PRICING_STRATEGY[]): {
    isValidSelection: boolean;
    mainPricingStrategy: PRICING_STRATEGY | null;
    compatiblePricingStrategies: PRICING_STRATEGY[];
} {
    const compatiblePricingStrategiesSet = new Set(PRICING_STRATEGY_SCHEMA.options);
    let mainPricingStrategy: PRICING_STRATEGY = PRICING_STRATEGY_SCHEMA.enum.STANDARD;

    const selectedFrancoCaseCount = selectedPricingStrategies.filter(
        pricingStrategy => pricingStrategy === PRICING_STRATEGY_SCHEMA.enum.FRANCO
    ).length;
    const selectedMerchantCaseCount = selectedPricingStrategies.filter(
        pricingStrategy => pricingStrategy === PRICING_STRATEGY_SCHEMA.enum.MERCHANT
    ).length;

    if (
        selectedFrancoCaseCount >= 2 ||
        selectedMerchantCaseCount >= 2 ||
        (selectedFrancoCaseCount >= 1 && selectedMerchantCaseCount >= 1)
    ) {
        return {
            isValidSelection: false,
            mainPricingStrategy: null,
            compatiblePricingStrategies: [],
        };
    }

    if (selectedFrancoCaseCount >= 1 || selectedMerchantCaseCount >= 1) {
        compatiblePricingStrategiesSet.delete(PRICING_STRATEGY_SCHEMA.enum.FRANCO);
        compatiblePricingStrategiesSet.delete(PRICING_STRATEGY_SCHEMA.enum.MERCHANT);
        mainPricingStrategy =
            selectedFrancoCaseCount >= 1 ? PRICING_STRATEGY_SCHEMA.enum.FRANCO : PRICING_STRATEGY_SCHEMA.enum.MERCHANT;
    }

    return {
        isValidSelection: true,
        mainPricingStrategy,
        compatiblePricingStrategies: [...compatiblePricingStrategiesSet],
    };
}
